module.exports = __webpack_public_path__ + "media/wave_solder_pallets/stiffener-bars-a0c6810f.png";